module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-lookup"
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    on: {
      "focus": _vm.showLookupDialog
    },
    model: {
      value: (_vm.lookupValue.name),
      callback: function($$v) {
        _vm.$set(_vm.lookupValue, "name", $$v)
      },
      expression: "lookupValue.name"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.showLookupDialog
    },
    slot: "suffix"
  })]), _vm._v(" "), _c('rt-lookup-dialog', {
    ref: "lookupDialog",
    attrs: {
      "entity": _vm.entity,
      "request-url": _vm.dialogRequestUrl,
      "dialog-title": _vm.dialogTitle,
      "name-field": _vm.nameField,
      "id-field": _vm.idField,
      "display-fields": _vm.dialogDisplayFields,
      "orderby-fields": _vm.dialogOrderbyFields,
      "custom-conditions": _vm.dialogCustomConditions,
      "filter-fields": _vm.dialogFilterFields,
      "return-fields": _vm.dialogReturnFields,
      "new_industry_id": _vm.new_industry_id,
      "new_orderId": _vm.new_orderId,
      "canCreate": _vm.canCreate
    },
    on: {
      "data-selected": _vm.handleDataSelected
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7568a429"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/lookup/src/lookup.vue
// module id = 1452
// module chunks = 116